export const initialCategories = [
  {
    id: 1,
    name: "Material de Construção",
    description: "Materiais para obras e reformas",
    totalProducts: 0,
  },
  {
    id: 2,
    name: "Material de Escritório",
    description: "Suprimentos para escritório",
    totalProducts: 0,
  },
  {
    id: 3,
    name: "Equipamentos",
    description: "Equipamentos e ferramentas",
    totalProducts: 0,
  },
];
